module.exports = __webpack_public_path__ + "img/quote.a09070e1.svg";